export const monthlyViewType: any = {
  internal: 1,
  hybrid: 2,
  intelypro: 3
};
